export { DashboardService } from "app/services/entidades/dashboard.service";
export { CustomersService } from "app/services/entidades/customers.service";
export { EventsService } from "app/services/entidades/events.service";
export { ReportsService } from "app/services/entidades/reports.service";
export { RoleService } from "app/services/entidades/role.service";
export { StatusService } from "app/services/entidades/status.service";
export { TimerService } from "app/services/funcional/timer.service";
export { AuthService } from "app/services/entidades/auth.service";
export { UsersService } from "app/services/entidades/users.service";

// export { UtilService } from "app/services/funcional/util.service";
export { TimeService } from "app/services/entidades/time.service";




// WEBPACK FOOTER //
// ./src/app/services/services.index.ts